export default __webpack_public_path__ + "static/media/box.cc67cd05.svg";